import { UISDK } from "@/ui-sdk";
import { parseHandles, updateShopifyImage } from "../utils";

export default function handleBanner(element: HTMLElement, sdk: UISDK) {
  const val = element.getAttribute("data-helium-banner-items");
  if (!val) {
    console.log("No valid 'data-helium-banner-items-*' attribute found.");
    return;
  }

  let images = parseHandles(val);
  images.map((img) => updateShopifyImage(img));

  const imgEle = element.querySelector("img");
  const h2Ele = element.querySelector("h2");
  const btnEle = element.querySelector("button");

  if (h2Ele && imgEle && btnEle) {
    const data = sdk.getBannerData(images);
    data.forEach(({ imgSrc, imgAlt, h2Text, btnText }) => {
      imgEle.setAttribute("src", imgSrc);
      imgEle.setAttribute("alt", imgAlt);
      h2Ele.innerHTML = h2Text;
      btnEle.innerHTML = btnText;
    });
    console.log("Updated banner:");
  } else {
    console.log("Some elements are missing in the banner.");
  }
}
